import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const formatErr = (d) => {
    if (!d) return "Login failed";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return d?.msg || String(d);
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      toast.success("Welcome back, Admin.");
      navigate("/admin");
    } catch (err) {
      const msg = formatErr(err.response?.data?.detail) || err.message;
      setError(msg);
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md border border-white/10 p-8 lg:p-10 bg-[#0E0E0E]">
        <img src={LOGO_URL} alt="MileForge" className="h-16 w-auto object-contain mb-2 -ml-3" />
        <div className="flex items-center gap-3 mb-1">
          <Lock size={18} className="text-[#D96A1B]" />
          <div className="overline">Restricted</div>
        </div>
        <h1 className="font-display text-3xl uppercase tracking-tight">Admin Login</h1>
        <p className="text-sm text-white/55 font-body mt-2">Authorized personnel only.</p>

        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <label className="overline block mb-2">Email</label>
            <input
              data-testid="admin-login-email"
              required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@mileforge.in"
              className="w-full bg-[#111] border border-white/15 px-4 py-3 focus:outline-none focus:border-[#D96A1B] font-body"
            />
          </div>
          <div>
            <label className="overline block mb-2">Password</label>
            <input
              data-testid="admin-login-password"
              required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full bg-[#111] border border-white/15 px-4 py-3 focus:outline-none focus:border-[#D96A1B] font-body"
            />
          </div>
          {error && <div data-testid="admin-login-error" className="text-sm text-[#D96A1B] font-body">{error}</div>}
          <button data-testid="admin-login-submit" disabled={loading} className="btn-orange w-full justify-center">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
